module.exports = __webpack_public_path__ + "assets/img/user-energy.8b71b936.png";